import type { NetworkVolDetail, NetworkVolDetailSelectionParams } from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchNetworkVolDetail } from '../queries/networkVolDetail.queries'

export const useNetworkVolDetail = (
  selection: NetworkVolDetailSelectionParams,
  enabled = true,
): UseQueryResult<NetworkVolDetail, unknown> =>
  useQuery({
    queryKey: [
      'get-network-vol-detail',
      selection.storeIds,
      selection.storeAgeFilter,
      selection.ageStoreIds,
      selection.comparableStoreIds,
      selection.startDate,
      selection.endDate,
      selection.comparableStartDate,
      selection.comparableEndDate,
    ],
    queryFn: () => fetchNetworkVolDetail(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
